<template>
  <div class="price-block">
    <p class="price-block__title">
      Расценки
    </p>
    <pSwitch
      v-model="searchStore.searchOptions.priceInfo.typeChecked"
      firstLabel="Апартаменты"
      secondLabel="Выезд"
    />
    <pSwitch
      v-model="searchStore.searchOptions.priceInfo.isNight"
      firstLabel="День"
      secondLabel="Ночь"
    />
    <DigitalBlock
        v-model:first="searchStore.searchOptions.priceInfo.oneHour.from"
        v-model:second="searchStore.searchOptions.priceInfo.oneHour.to"
        :title="'1 час'"
        orText="-"
        :firstPlaceholder="'От ₽'"
        :secondPlaceholder="'До ₽'"
    />
    <DigitalBlock
        v-model:first="searchStore.searchOptions.priceInfo.twoHour.from"
        v-model:second="searchStore.searchOptions.priceInfo.twoHour.to"
        :title="twoHourLabel"
        orText="-"
        :firstPlaceholder="'От ₽'"
        :secondPlaceholder="'До ₽'"
    />
  </div>
</template>

<script setup lang="ts">
import pSwitch from '@/common/pSwitch/pSwitch.vue'
import DigitalBlock from "@/searchSection/components/SearchPanel/DigitalBlock.vue";
import {useSearchStore} from "@/searchSection/store/searchStore";
import {computed} from "vue";
const searchStore = useSearchStore()

const twoHourLabel = computed(() => {
  return searchStore.searchOptions.priceInfo.isNight ? 'Ночь' : '2 часа'
})
</script>

<style scoped lang="scss">
.price-block {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 12px;
  row-gap: 20px;
  margin-top: 20px;

  @media screen and (max-width: 580px) {
    grid-template-columns: 1fr;
  }

  &__title {
    font-family: "Inter", sans-serif;
    font-weight: 700;
    grid-column: 1/3;

    @media screen and (max-width: 580px) {
      grid-column: initial;
    }
  }

  .p-switch {
    display: flex;
    align-items: center;
    gap: 10px;

    @media screen and (max-width: 580px) {
      grid-column: initial;
    }
  }
}
</style>